import { ListType } from '@convergence/types';
import { getError } from '../util';
import { AnalysisActionSwitch } from './analysis-action-switch';
import { ActionInputProps } from './types';
import { actionDataFromTreeAndPath } from './util';

export function AnalysisListAction(props: ActionInputProps<ListType>) {
  let actionData =
    actionDataFromTreeAndPath(props.tree, props.propertyPath) ?? [];

  const error = getError(props.errors, props.propertyPath);

  return (
    <div className="py-2">
      <div className="flex gap-2 items-center">
        {props.name && <span className="font-bold ">{props.name}</span>}
      </div>
      <div className="flex flex-col gap-2 pl-4">
        <AnalysisActionSwitch
          value={props.value._schema}
          tree={props.tree}
          errors={props.errors}
          propertyPath={[...props.propertyPath, '_value', String(0)]}
          name=""
          onChange={props.onChange}
        />
      </div>
      {error && <p className="text-red-500">{error.message}</p>}
    </div>
  );
}
